export enum TableRowColorType{
    Background = 'background',
    Foreground = 'foreground'
}